module.exports = __webpack_public_path__ + "img/img88.c08348db.svg";